import i18n from 'i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { deleteOCClaims } from '@/views/screens/Claims/data-provider/delete-over-charge-claims';

type DeleteOCClaimsParams = {
  fbocKeys: string;
  handleSuccess?: () => void;
};

export const useDeleteOCClaims = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ fbocKeys }: DeleteOCClaimsParams) => deleteOCClaims({ fbocKeys }),
    onError: () => {
      showNotification({
        message: i18n.t('translation:default.notification.claimsDeletedFailed'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: (_data, { handleSuccess }) => {
      showNotification({
        message: i18n.t('translation:default.notification.claimsDeleted'),
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      handleSuccess?.();
      queryClient.invalidateQueries({ exact: false, queryKey: ['claims-over-charge-list'] });
    },
  });
};
